<template>
  <div class="price-System">
    <div style="padding:5px 20px">
      <!--  @tab-click="handleClick" -->
      <el-tabs v-model="activeDelivery">
        <!-- 配送计费 -->
        <el-tab-pane label="配送计费" name="first">
          <!-- 公里费计数 -->
          <el-card class="kilometre">
            <el-radio v-model="radio1" label="0">
              公里数计费
            </el-radio>
            <el-button
              type="primary"
              plain
              style="float:right;width:200px;"
              @click="addKilometre"
            >
              + 增加公里数
            </el-button>
            <el-form ref="KMruleForm" :model="kilometreForm" class="kmForm">
              <div
                v-for="(item, index) in kilometreForm.domains"
                :key="item.key"
              >
                <el-row :gutter="10">
                  <el-col :span="5">
                    <el-col :span="10" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="起步价"
                        placement="top"
                      >
                        <el-form-item
                          label-width="0"
                          :prop="'domains.' + index + '.price'"
                          :rules="KMrules.price"
                        >
                          <el-input
                            v-model.number="item.price"
                            placeholder="起步价"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">元</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="14" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="起步公里数"
                        placement="top"
                      >
                        <el-form-item
                          label="每"
                          label-width="25px"
                          style="margin-left:8px;"
                          :prop="'domains.' + index + '.limitEnd'"
                          :rules="KMrules.limitEnd"
                        >
                          <el-input
                            v-model.number="item.limitEnd"
                            placeholder="起步公里数"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">Km</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                  </el-col>
                  <el-col :span="1" class="iconCount">
                    <i class="el-icon-plus" />
                  </el-col>
                  <el-col :span="5">
                    <el-col :span="23" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="公里单价"
                        placement="top"
                      >
                        <el-form-item
                          label-width="0"
                          :prop="'domains.' + index + '.unitPrice'"
                          :rules="KMrules.unitPrice"
                        >
                          <el-input
                            v-model.number="item.unitPrice"
                            placeholder="公里单价"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">元/Km</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                  </el-col>

                  <el-col :span="1" class="iconCount">
                    <i class="el-icon-close" />
                  </el-col>
                  <el-col :span="6">
                    <el-col :span="24" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="公里数-起步公里数"
                        placement="top"
                      >
                        <el-form-item label-width="0">
                          <el-input placeholder="公里数-起步公里数" disabled>
                            <i slot="suffix">Km</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                  </el-col>
                  <el-col :span="1" class="iconCount">
                    <i>=</i>
                  </el-col>
                  <el-col :span="5">
                    <el-col :span="kilometreWidth" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="单票运费"
                        placement="top"
                      >
                        <el-form-item label-width="0">
                          <el-input placeholder="单票运费" disabled>
                            <i slot="suffix">元</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <template v-if="isRemoveKilometre">
                      <el-col :span="2">
                        <el-button type="text" @click="removeKilometre(item)">
                          删除
                        </el-button>
                      </el-col>
                    </template>
                  </el-col>
                </el-row>
              </div>
            </el-form>
          </el-card>

          <!-- 线路计费 -->
          <el-card v-if="isShowLineCard" class="line">
            <el-radio v-model="radio1" label="2">
              线路计费
            </el-radio>
            <el-button
              type="primary"
              plain
              style="float:right;width:200px;"
              @click="addLine"
            >
              + 增加线路
            </el-button>
            <el-form
              ref="lineRuleForm"
              :model="lineForm"
              class="lineForm"
              label-width="80px"
            >
              <div v-for="(item, index) in lineForm.domains" :key="item.key">
                <el-row :gutter="10">
                  <el-col :span="11">
                    <el-form-item label="线路选择">
                      <el-select
                        v-model="item.lineData"
                        placeholder="请选择线路"
                        style="width:100%"
                      >
                        <el-option
                          v-for="(item1, index1) in item.lineOptions"
                          :key="index1"
                          :label="item1.label"
                          :value="item1.value"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" class="iconCount">
                    <i>=</i>
                  </el-col>
                  <el-col :span="12">
                    <el-col :span="lineWidth" class="contentBox">
                      <el-form-item
                        :prop="'domains.' + index + '.linePrice'"
                        :rules="lineRules.linePrice"
                        label-width="0"
                      >
                        <el-input
                          v-model.number="item.linePrice"
                          placeholder="运费"
                          type="number"
                          min="0.00"
                          step="0.01"
                        >
                          <i slot="suffix">元</i>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <template v-if="isRemove">
                      <el-col :span="2">
                        <el-button type="text" @click="removeLine(item)">
                          删除
                        </el-button>
                      </el-col>
                    </template>
                  </el-col>
                </el-row>
              </div>
            </el-form>
          </el-card>
          <!-- 区划件数计费 -->
          <el-card class="line">
            <el-radio v-model="radio1" label="3">
              区划件数计费
            </el-radio>
            <el-button
              type="primary"
              plain
              style="float:right;width:200px;"
              @click="addAreaChild"
            >
              + 增加区划件数计费
            </el-button>
            <Area ref="areaData" />
          </el-card>

          <!-- 点数计费 -->
          <el-card class="unit">
            <el-radio v-model="radio1" label="4">
              点数计费
            </el-radio>
            <el-button
              type="primary"
              plain
              style="float:right;width:200px;"
              @click="addSpot"
            >
              + 添加点数计费
            </el-button>
            <el-form ref="spotRuleForm" :model="spotForm" label-width="30px">
              <div
                v-for="(item, index) in spotForm.spotdomains"
                :key="item.key"
                class="FormBox"
              >
                <el-row :gutter="10">
                  <el-col :span="11" class="margintop">
                    <el-col :span="8" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="起步价"
                        placement="top"
                      >
                        <el-form-item
                          label-width="0"
                          :prop="'spotdomains.' + index + '.price'"
                          :rules="spotRules.price"
                        >
                          <el-input
                            v-model.number="item.price"
                            placeholder="起步价"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">元</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="8" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="起步点数"
                        placement="top"
                      >
                        <el-form-item
                          label="每"
                          :prop="'spotdomains.' + index + '.limitEnd'"
                          :rules="spotRules.limitEnd"
                        >
                          <el-input
                            v-model.number="item.limitEnd"
                            placeholder="起步点数"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">点</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="8" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="起步公里数"
                        placement="top"
                      >
                        <el-form-item
                          label="每"
                          :prop="'spotdomains.' + index + '.rangeEnd'"
                          :rules="spotRules.rangeEnd"
                        >
                          <el-input
                            v-model.number="item.rangeEnd"
                            placeholder="起步公里数"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">Km</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                  </el-col>
                  <el-col :span="1" class="iconCount margintop">
                    <i class="el-icon-plus" />
                  </el-col>
                  <el-col :span="7">
                    <el-col :span="9" class="margintop">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="点数单价"
                        placement="top"
                      >
                        <el-form-item
                          :prop="'spotdomains.' + index + '.unitPrice'"
                          :rules="spotRules.unitPrice"
                          label-width="0"
                        >
                          <el-input
                            v-model.number="item.unitPrice"
                            placeholder="点数单价"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">元/点</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="2" class="iconCount margintop">
                      <i class="el-icon-close" />
                    </el-col>
                    <el-col :span="13" class="margintop">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="超出起步点数"
                        placement="top"
                      >
                        <el-form-item label-width="0">
                          <!--<el-input
                            v-model="item.points"
                            placeholder="点数-起步点数"
                            disabled
                          />-->
                          <el-input placeholder="点数-起步点数" disabled>
                            <i slot="suffix">点</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                  </el-col>
                  <el-col :span="1" class="iconCount margintop">
                    <i>=</i>
                  </el-col>
                  <el-col :span="4" class="margintop">
                    <el-col :span="spotWidth" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="单票运费"
                        placement="top"
                      >
                        <el-form-item label-width="0">
                          <el-input
                            v-model.number="item.totalPrice"
                            placeholder="单票运费"
                            disabled
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">元</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <template v-if="spotRemove">
                      <el-col :span="2">
                        <el-button type="text" @click="removeSpot(item)">
                          删除
                        </el-button>
                      </el-col>
                    </template>
                  </el-col>
                </el-row>
                <el-row v-if="false" :gutter="10" style="top:-30px;">
                  <el-col :span="7" :offset="12">
                    <el-col :span="9" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="公里单价"
                        placement="top"
                      >
                        <el-form-item
                          :prop="'spotdomains.' + index + '.rangeUnitPrice'"
                          :rules="spotRules.rangeUnitPrice"
                          label-width="0"
                          class="marginNone"
                        >
                          <el-input
                            v-model.number="item.rangeUnitPrice"
                            placeholder="公里单价"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">元/Km</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="2" class="iconCount">
                      <i class="el-icon-close" />
                    </el-col>
                    <el-col :span="13" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="公里数-起步公里数"
                        placement="top"
                      >
                        <el-form-item label-width="0" class="marginNone">
                          <!--<el-input
                          v-model.number="item.points"
                          placeholder="公里数-起步公里数"
                          disabled
                          />-->
                          <el-input placeholder="公里数-起步公里数" disabled>
                            <i slot="suffix">Km</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                  </el-col>
                </el-row>
              </div>
            </el-form>
          </el-card>

          <!-- 单位计费 -->
          <el-card class="Unit">
            <el-radio v-model="radio1" label="1">
              单位计费
            </el-radio>
            <!-- 重量计费 -->
            <el-row class="unitTitle" type="flex" justify="space-between">
              <el-col :span="6">
                重量计费
              </el-col>
              <el-col :span="3">
                <el-button
                  type="primary"
                  plain
                  class="addUnitStyle"
                  @click="addWeight"
                >
                  + 添加重量计费
                </el-button>
              </el-col>
            </el-row>
            <el-form
              ref="weightRuleForm"
              :model="weightForm"
              label-width="30px"
            >
              <div
                v-for="(item, index) in weightForm.weightdomains"
                :key="item.key"
                class="FormBox"
              >
                <el-row :gutter="10">
                  <el-col :span="11" class="margintop">
                    <el-col :span="8" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="起步价"
                        placement="top"
                      >
                        <el-form-item
                          :prop="'weightdomains.' + index + '.price'"
                          :rules="weightRules.price"
                          label-width="0"
                          class="marginNone"
                        >
                          <el-input
                            v-model.number="item.price"
                            placeholder="起步价"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">元</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="8" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="起步重量"
                        placement="top"
                      >
                        <el-form-item
                          label="每"
                          :prop="'weightdomains.' + index + '.limitEnd'"
                          :rules="weightRules.limitEnd"
                          style="margin-left:8px;"
                          class="marginNone"
                        >
                          <el-input
                            v-model.number="item.limitEnd"
                            placeholder="起步重量"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">Kg</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="8" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="起步公里数"
                        placement="top"
                      >
                        <el-form-item
                          style="margin-left:8px;"
                          label="每"
                          :prop="'weightdomains.' + index + '.rangeEnd'"
                          :rules="weightRules.rangeEnd"
                          class="marginNone"
                        >
                          <el-input
                            v-model.number="item.rangeEnd"
                            placeholder="起步公里数"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">Km</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                  </el-col>
                  <el-col :span="1" class="iconCount margintop">
                    <i class="el-icon-plus" />
                  </el-col>
                  <el-col :span="7">
                    <el-col :span="9" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="重量单价"
                        placement="top"
                      >
                        <el-form-item
                          :prop="'weightdomains.' + index + '.unitPrice'"
                          :rules="weightRules.unitPrice"
                          label-width="0"
                          class="marginNone"
                        >
                          <el-input
                            v-model.number="item.unitPrice"
                            placeholder="重量单价"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">元/Kg</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="2" class="iconCount">
                      <i class="el-icon-close" />
                    </el-col>
                    <el-col :span="13" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="超出起步重量"
                        placement="top"
                      >
                        <el-form-item label-width="0" class="marginNone">
                          <!-- <el-input
                          v-model="item.points"
                          placeholder="重量-起步重量"
                          disabled
                        class="marginNone"
                          />-->
                          <el-input placeholder="重量-起步重量" disabled>
                            <i slot="suffix">Kg</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                  </el-col>
                  <el-col :span="1" class="iconCount margintop">
                    <i>=</i>
                  </el-col>
                  <el-col :span="4" class="margintop">
                    <el-col :span="weightWidth" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="单票运费"
                        placement="top"
                      >
                        <el-form-item label-width="0">
                          <el-input
                            v-model.number="item.totalPrice"
                            placeholder="单票运费"
                            disabled
                            class="marginNone"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">元</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <template v-if="isWeightRemove">
                      <el-col :span="2">
                        <el-button type="text" @click="removeWeight(item)">
                          删除
                        </el-button>
                      </el-col>
                    </template>
                  </el-col>
                </el-row>
                <el-row :gutter="10" style="top:-30px;">
                  <el-col :span="7" :offset="12">
                    <el-col :span="9" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="公里单价"
                        placement="top"
                      >
                        <el-form-item
                          :prop="'weightdomains.' + index + '.rangeUnitPrice'"
                          :rules="weightRules.rangeUnitPrice"
                          label-width="0"
                          class="marginNone"
                        >
                          <el-input
                            v-model.number="item.rangeUnitPrice"
                            placeholder="公里单价"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">元/Km</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="2" class="iconCount">
                      <i class="el-icon-close" />
                    </el-col>
                    <el-col :span="13" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="公里数-起步公里数"
                        placement="top"
                      >
                        <el-form-item label-width="0" class="marginNone">
                          <!--<el-input
                          v-model="item.points"
                          placeholder="公里数-起步公里数"
                        disabled
                        class="marginNone"
                          />-->
                          <el-input placeholder="公里数-起步公里数" disabled>
                            <i slot="suffix">Km</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                  </el-col>
                </el-row>
              </div>
            </el-form>

            <!-- 件数计费 -->
            <el-row class="unitTitle">
              <el-col :span="6">
                件数计费
              </el-col>
              <el-col :span="3" style="float:right;">
                <el-button
                  type="primary"
                  plain
                  class="addUnitStyle"
                  @click="addPiece"
                >
                  + 添加件数计费
                </el-button>
              </el-col>
            </el-row>

            <el-form ref="pieceRuleForm" :model="pieceForm" label-width="30px">
              <div
                v-for="(item, index) in pieceForm.piecedomains"
                :key="item.key"
                class="FormBox"
              >
                <el-row :gutter="10">
                  <el-col :span="11" class="margintop">
                    <el-col :span="8" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="起步价"
                        placement="top"
                      >
                        <el-form-item
                          label-width="0"
                          :prop="'piecedomains.' + index + '.price'"
                          :rules="pieceRules.price"
                        >
                          <el-input
                            v-model.number="item.price"
                            placeholder="起步价"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">元</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="8" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="起步件数"
                        placement="top"
                      >
                        <el-form-item
                          label="每"
                          :prop="'piecedomains.' + index + '.limitEnd'"
                          :rules="pieceRules.limitEnd"
                        >
                          <el-input
                            v-model.number="item.limitEnd"
                            placeholder="起步件数"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">件</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="8" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="起步公里数"
                        placement="top"
                      >
                        <el-form-item
                          label="每"
                          :prop="'piecedomains.' + index + '.rangeEnd'"
                          :rules="pieceRules.rangeEnd"
                        >
                          <el-input
                            v-model.number="item.rangeEnd"
                            placeholder="起步公里数"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">Km</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                  </el-col>
                  <el-col :span="1" class="iconCount margintop">
                    <i class="el-icon-plus" />
                  </el-col>
                  <el-col :span="7">
                    <el-col :span="9" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="件数单价"
                        placement="top"
                      >
                        <el-form-item
                          :prop="'piecedomains.' + index + '.unitPrice'"
                          :rules="pieceRules.unitPrice"
                          label-width="0"
                        >
                          <el-input
                            v-model.number="item.unitPrice"
                            placeholder="件数单价"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">元/件</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="2" class="iconCount">
                      <i class="el-icon-close" />
                    </el-col>
                    <el-col :span="13" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="超出起步件数"
                        placement="top"
                      >
                        <el-form-item label-width="0">
                          <!--<el-input
                            v-model="item.points"
                            placeholder="件数-起步件数"
                            disabled
                          />-->
                          <el-input placeholder="件数-起步件数" disabled>
                            <i slot="suffix">件</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                  </el-col>
                  <el-col :span="1" class="iconCount margintop">
                    <i>=</i>
                  </el-col>
                  <el-col :span="4" class="margintop">
                    <el-col :span="pieceWidth" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="单票运费"
                        placement="top"
                      >
                        <el-form-item label-width="0">
                          <el-input
                            v-model.number="item.totalPrice"
                            placeholder="单票运费"
                            disabled
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">元</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <template v-if="pieceRemove">
                      <el-col :span="2">
                        <el-button type="text" @click="removePiece(item)">
                          删除
                        </el-button>
                      </el-col>
                    </template>
                  </el-col>
                </el-row>
                <el-row :gutter="10" style="top:-30px;">
                  <el-col :span="7" :offset="12">
                    <el-col :span="9" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="公里单价"
                        placement="top"
                      >
                        <el-form-item
                          :prop="'piecedomains.' + index + '.rangeUnitPrice'"
                          :rules="pieceRules.rangeUnitPrice"
                          label-width="0"
                          class="marginNone"
                        >
                          <el-input
                            v-model.number="item.rangeUnitPrice"
                            placeholder="公里单价"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">元/Km</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="2" class="iconCount">
                      <i class="el-icon-close" />
                    </el-col>
                    <el-col :span="13" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="公里数-起步公里数"
                        placement="top"
                      >
                        <el-form-item label-width="0" class="marginNone">
                          <el-input placeholder="公里数-起步公里数" disabled>
                            <i slot="suffix">Km</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                  </el-col>
                </el-row>
              </div>
            </el-form>

            <!-- 体积计费 -->
            <el-row class="unitTitle">
              <el-col :span="6">
                体积计费
              </el-col>
              <el-col :span="3" style="float:right;">
                <el-button
                  type="primary"
                  plain
                  class="addUnitStyle"
                  @click="addVolume"
                >
                  + 添加体积计费
                </el-button>
              </el-col>
            </el-row>

            <el-form
              ref="volumeRuleForm"
              :model="volumeForm"
              label-width="30px"
            >
              <div
                v-for="(item, index) in volumeForm.volumedomains"
                :key="item.key"
                class="FormBox"
              >
                <el-row :gutter="10">
                  <el-col :span="11" class="margintop">
                    <el-col :span="8" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="起步价"
                        placement="top"
                      >
                        <el-form-item
                          label-width="0"
                          :prop="'volumedomains.' + index + '.price'"
                          :rules="volumeRules.price"
                          class="marginNone"
                        >
                          <el-input
                            v-model.number="item.price"
                            placeholder="起步价"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">元</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="8" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="起步体积"
                        placement="top"
                      >
                        <el-form-item
                          class="marginNone"
                          label="每"
                          :prop="'volumedomains.' + index + '.limitEnd'"
                          :rules="volumeRules.limitEnd"
                        >
                          <el-input
                            v-model.number="item.limitEnd"
                            placeholder="起步体积"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">方</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="8" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="起步公里数"
                        placement="top"
                      >
                        <el-form-item
                          class="marginNone"
                          label="每"
                          :prop="'volumedomains.' + index + '.rangeEnd'"
                          :rules="volumeRules.rangeEnd"
                        >
                          <el-input
                            v-model.number="item.rangeEnd"
                            placeholder="起步公里数"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">Km</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                  </el-col>
                  <el-col :span="1" class="iconCount margintop">
                    <i class="el-icon-plus" />
                  </el-col>
                  <el-col :span="7">
                    <el-col :span="9" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="点数单价"
                        placement="top"
                      >
                        <el-form-item
                          :prop="'volumedomains.' + index + '.unitPrice'"
                          :rules="volumeRules.unitPrice"
                          label-width="0"
                        >
                          <el-input
                            v-model.number="item.unitPrice"
                            placeholder="体积单价"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">元/方</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="2" class="iconCount">
                      <i class="el-icon-close" />
                    </el-col>
                    <el-col :span="13" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="超出起步体积"
                        placement="top"
                      >
                        <el-form-item label-width="0">
                          <!--<el-input
                            v-model="item.points"
                            placeholder="体积-起步体积"
                            disabled
                          />-->
                          <el-input placeholder="体积-起步体积" disabled>
                            <i slot="suffix">方</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                  </el-col>
                  <el-col :span="1" class="iconCount margintop">
                    <i>=</i>
                  </el-col>
                  <el-col :span="4" class="margintop">
                    <el-col :span="volumeWidth" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="单票运费"
                        placement="top"
                      >
                        <el-form-item label-width="0">
                          <el-input
                            v-model.number="item.totalPrice"
                            placeholder="单票运费"
                            disabled
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">元</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <template v-if="volumeRemove">
                      <el-col :span="2">
                        <el-button type="text" @click="removeVolume(item)">
                          删除
                        </el-button>
                      </el-col>
                    </template>
                  </el-col>
                </el-row>
                <el-row :gutter="10" style="top:-30px;">
                  <el-col :span="7" :offset="12">
                    <el-col :span="9" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="公里单价"
                        placement="top"
                      >
                        <el-form-item
                          :prop="'volumedomains.' + index + '.rangeUnitPrice'"
                          :rules="volumeRules.rangeUnitPrice"
                          label-width="0"
                          class="marginNone"
                        >
                          <el-input
                            v-model.number="item.rangeUnitPrice"
                            placeholder="公里单价"
                            type="number"
                            min="0.00"
                            step="0.01"
                          >
                            <i slot="suffix">元/Km</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="2" class="iconCount">
                      <i class="el-icon-close" />
                    </el-col>
                    <el-col :span="13" class="contentBox">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="公里数-起步公里数"
                        placement="top"
                      >
                        <el-form-item label-width="0" class="marginNone">
                          <!--<el-input
                          v-model="item.points"
                          placeholder="公里数-起步公里数"
                          disabled
                          />-->
                          <el-input placeholder="公里数-起步公里数" disabled>
                            <i slot="suffix">Km</i>
                          </el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                  </el-col>
                </el-row>
              </div>
            </el-form>
          </el-card>

          <!-- 包车计费 -->
          <vehiclePrice ref="vehiclePriceData" />

          <!-- 装卸费 -->
          <Handling ref="HandlingData" />

          <el-row type="flex" justify="center" style="margin-top:10px;">
            <el-col :span="6">
              <!-- 提交按钮 -->
              <el-button
                v-if="getLimit('shipment_price_add_button')"
                type="primary"
                @click="submitForm()"
              >
                立即创建
              </el-button>
              <!-- 重置 -->
              <el-button
                v-if="getLimit('shipment_price_reset_button')"
                @click="resetForm"
              >
                重置
              </el-button>
            </el-col>
          </el-row>
        </el-tab-pane>

        <!-- 运输计费 -->
        <el-tab-pane v-if="isShow" label="运输计费" name="second">
          555555
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import vehiclePrice from "./compoments/vehiclePrice.vue";
import Handling from "./compoments/Handling.vue";
import Area from "./compoments/area.vue";
import { Price } from "@/api/ctms";
import { Loading } from "element-ui";
export default {
  name: "PriceSystem",
  components: {
    vehiclePrice,
    Handling,
    Area
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      partyCurrentType: "",
      isShowLineCard: false,
      volumeWidth: 19,
      volumeRemove: false,
      spotWidth: 19,
      spotRemove: false,
      pieceRemove: false,
      isShow: false,
      pieceWidth: 19,
      lineWidth: 22,
      weightWidth: 19,
      kilometreWidth: 22,
      isWeightRemove: false,
      isRemoveKilometre: false,
      isRemove: false,
      vehicleType: "",
      activeDelivery: "first",
      radio1: "0",
      priceReturnData: {},
      vehicleData: [],
      dictData: [],
      areaData: [],
      lineOptionsData: [],
      kilometreForm: {
        // 公里计价
        domains: [
          {
            defaultBillingMethod: "0",
            limitEnd: "", //千克/方/件/点计量范围
            limitFrom: 0, //千克/方/件/点计量起始范围,
            points: 0, //百分比
            price: "",
            priceItem: "01", //价格项目（01配送计费，02运输计费）
            priceName: "公里数计费",
            priceType: "0", //费用类别（0, "公里数计费",1,"重量计费",2, "件数计费",3, "点数计费",4, "体积计费",5, "包车计费",6, "装卸费",7, "车数计费",8, "线路计费",9, "加急费",10, "信息费",11, "代收款手续费",12, "车型费用")13, "综合最大值";）
            rangeEnd: "", //组合计费 里程终止范围
            rangeFrom: "", //组合计费 里程起始范围
            rangeUnitPrice: 0,
            routelineCode: "", //线路code或者是车型code
            shipmentUserCode: "", //托运人用户code，对应sys_party表code
            unit: 0, //单位（非必传）
            unitPrice: "" //（单价）
          }
        ]
      },
      KMrules: {
        price: [{ type: "number", message: "起步价必须为数字值" }],
        limitEnd: [{ type: "number", message: "起步公里数必须为数字值" }],
        unitPrice: [{ type: "number", message: "公里单价必须为数字值" }]
      },
      lineForm: {
        // 线路计价  暂时不用
        domains: [
          {
            lineData: "",
            lineOptions: this.lineOptionsData,
            linePrice: ""
          }
        ]
      },
      lineRules: {
        linePrice: [{ type: "number", message: "运费必须为数字值" }]
      },
      weightForm: {
        // 重量计价
        weightdomains: [
          {
            defaultBillingMethod: "0", //默认计费方式 0:公里数计费,1:重量/体积/件数/点数计费,2:线路计费
            limitEnd: "", //千克/方/件/点计量范围
            limitFrom: "", //千克/方/件/点计量起始范围,
            points: "", //百分比
            price: "", //起步价
            priceItem: "01", //价格项目（01配送计费，02运输计费）
            priceName: "重量计费", //费用类别名称（公里数计费）
            priceType: "1", //费用类别（0, "公里数计费",1,"重量计费",2, "件数计费",3, "点数计费",4, "体积计费",5, "包车计费",6, "装卸费",7, "车数计费",8, "线路计费",9, "加急费",10, "信息费",11, "代收款手续费",12, "车型费用")13, "综合最大值";）
            rangeEnd: "", //组合计费 里程终止范围
            rangeFrom: 0, //组合计费 里程起始范围
            rangeUnitPrice: "", //组合计费 里程单价
            routelineCode: "", //线路code或者是车型code
            shipmentUserCode: "", //托运人用户code，对应sys_party表code（非必传）
            unit: "0", //单位（非必传）WaybillExpense
            unitPrice: "" //（单价）
          }
        ]
      },
      weightRules: {
        price: [{ type: "number", message: "起步价必须为数字值" }],
        limitEnd: [{ type: "number", message: "起步重量必须为数字值" }],
        unitPrice: [{ type: "number", message: "重量单价必须为数字值" }],
        rangeUnitPrice: [{ type: "number", message: "公里单价必须为数字值" }],
        rangeEnd: [{ type: "number", message: "起步公里数必须为数字值" }]
      },
      pieceForm: {
        // 件数计费
        piecedomains: [
          {
            defaultBillingMethod: "0", //默认计费方式 0:公里数计费,1:重量/体积/件数/点数计费,2:线路计费
            limitEnd: "", //千克/方/件/点计量范围
            limitFrom: "", //千克/方/件/点计量起始范围,
            points: 0, //百分比
            price: "", //起步价
            priceItem: "01", //价格项目（01配送计费，02运输计费）
            priceName: "件数计费", //费用类别名称（公里数计费）
            priceType: 2, //费用类别（0, "公里数计费",1,"重量计费",2, "件数计费",3, "点数计费",4, "体积计费",5, "包车计费",6, "装卸费",7, "车数计费",8, "线路计费",9, "加急费",10, "信息费",11, "代收款手续费",12, "车型费用")13, "综合最大值";）
            rangeEnd: "", //组合计费 里程终止范围
            rangeFrom: "", //组合计费 里程起始范围
            rangeUnitPrice: "", //组合计费 里程单价
            routelineCode: "", //线路code或者是车型code
            shipmentUserCode: "", //托运人用户code，对应sys_party表code（非必传）
            unit: "1", //单位（非必传）
            unitPrice: "" //（单价）
          }
        ]
      },
      pieceRules: {
        price: [
          { type: "number", message: "起步价必须为数字值", trigger: "blur" }
        ],
        limitEnd: [{ type: "number", message: "起步件数必须为数字值" }],
        unitPrice: [{ type: "number", message: "件数单价必须为数字值" }],
        rangeEnd: [{ type: "number", message: "起步公里数必须为数字值" }],
        rangeUnitPrice: [{ type: "number", message: "公里单价必须为数字值" }]
      },
      spotForm: {
        // 点数计费
        spotdomains: [
          {
            defaultBillingMethod: "0", //默认计费方式 0:公里数计费,1:重量/体积/件数/点数计费,2:线路计费
            limitEnd: "", //千克/方/件/点计量范围
            limitFrom: "", //千克/方/件/点计量起始范围,
            points: 0, //百分比
            price: "", //起步价
            priceItem: "01", //价格项目（01配送计费，02运输计费）
            priceName: "点数计费", //费用类别名称（公里数计费）
            priceType: 3, //费用类别（0, "公里数计费",1,"重量计费",2, "件数计费",3, "点数计费",4, "体积计费",5, "包车计费",6, "装卸费",7, "车数计费",8, "线路计费",9, "加急费",10, "信息费",11, "代收款手续费",12, "车型费用")13, "综合最大值";）
            rangeEnd: "", //组合计费 里程终止范围
            rangeFrom: "", //组合计费 里程起始范围
            rangeUnitPrice: "", //组合计费 里程单价
            routelineCode: "", //线路code或者是车型code
            shipmentUserCode: "", //托运人用户code，对应sys_party表code（非必传）
            unit: "2", //单位（非必传）
            unitPrice: "" //（单价）
          }
        ]
      },
      spotRules: {
        price: [{ type: "number", message: "起步价必须为数字值" }],
        rangeEnd: [{ type: "number", message: "起步公里数必须为数字值" }],
        limitEnd: [{ type: "number", message: "起步点数必须为数字值" }],
        unitPrice: [{ type: "number", message: "点数单价必须为数字值" }],
        rangeUnitPrice: [{ type: "number", message: "公里单价必须为数字值" }]
      },
      volumeForm: {
        // 体积计费
        volumedomains: [
          {
            defaultBillingMethod: "0", //默认计费方式 0:公里数计费,1:重量/体积/件数/点数计费,2:线路计费
            limitEnd: "", //千克/方/件/点计量范围
            limitFrom: "", //千克/方/件/点计量起始范围,
            points: 0, //百分比
            price: "", //起步价
            priceItem: "01", //价格项目（01配送计费，02运输计费）
            priceName: "体积计费", //费用类别名称（公里数计费）
            priceType: 4, //费用类别（0, "公里数计费",1,"重量计费",2, "件数计费",3, "点数计费",4, "体积计费",5, "包车计费",6, "装卸费",7, "车数计费",8, "线路计费",9, "加急费",10, "信息费",11, "代收款手续费",12, "车型费用")13, "综合最大值";）
            rangeEnd: "", //组合计费 里程终止范围
            rangeFrom: "", //组合计费 里程起始范围
            rangeUnitPrice: "", //组合计费 里程单价
            routelineCode: "", //线路code或者是车型code
            shipmentUserCode: "", //托运人用户code，对应sys_party表code（非必传）
            unit: "3", //单位（非必传）
            unitPrice: "" //（单价）
          }
        ]
      },
      volumeRules: {
        price: [{ type: "number", message: "起步价必须为数字值" }],
        limitEnd: [{ type: "number", message: "起步体积必须为数字值" }],
        rangeEnd: [{ type: "number", message: "起步公里数必须为数字值" }],
        unitPrice: [{ type: "number", message: "体积单价必须为数字值" }],
        rangeUnitPrice: [{ type: "number", message: "公单价必须为数字值" }]
      },
      initForm: {
        defaultBillingMethod: "", //默认计费方式 0:公里数计费,1:重量/体积/件数/点数计费,2:线路计费
        limitEnd: 0, //千克/方/件/点计量范围
        limitFrom: 0, //千克/方/件/点计量起始范围,
        points: 0, //百分比
        price: 0, //起步价
        priceItem: "01", //价格项目（01配送计费，02运输计费）
        priceName: "", //费用类别名称（公里数计费）
        priceType: "5", //费用类别（0, "公里数计费",1,"重量计费",2, "件数计费",3, "点数计费",4, "体积计费",5, "包车计费",6, "装卸费",7, "车数计费",8, "线路计费",9, "加急费",10, "信息费",11, "代收款手续费",12, "车型费用")13, "综合最大值";）
        rangeEnd: 0, //组合计费 里程终止范围
        rangeFrom: 0, //组合计费 里程起始范围
        rangeUnitPrice: 0, //组合计费 里程单价
        routelineCode: "", //线路code或者是车型code
        shipmentUserCode: "", //托运人用户code，对应sys_party表code
        unit: 0, //单位
        unitPrice: 0 //（单价）
      },
      postList: {
        shipmentUserCode: "",
        ctmsPriceStructureList: [],
        ctmsUserPriceStructure: {
          priceItem: "01", //价格项目（01配送计费，02运输计费）
          groupCode: "", //机构代码(非必传)
          shipmentUserCode: "", //托运人用户code，对应sys_party表code(非必传)
          isTotal: 0, //是否计算最大综合值，默认0否，1是
          isHanding: 0, //是否存在装卸费，默认0否，1是
          isUrgent: 0, //是否存在加急费，默认0否，1是
          isInfo: 0, //是否存在信息费，默认0否，1是
          isProcedure: 0 //是否存在代收款手续费，默认0否，1是
        }
      }
    };
  },
  created() {
    // this.getVehicleType();
    this.getUser();
    this.getlineOptionsData();
    this.getCurrentUser();
  },
  methods: {
    getUser() {
      const data =
        this.parentData == undefined ? "" : this.parentData.partyCode;
      request({
        url: `/ntocc-ctms-api/ctmsPriceStructure/getPartyType`,
        method: "get",
        params: { shipmentUserCode: data }
      }).then(response => {
        this.partyType = response.data.partyType;
        if ("PLAT_ADMIN" != this.partyType) {
          this.isShowLineCard = true;
        }
      });
    },
    getCurrentUser() {
      request({
        url: `/ntocc-basic-api/getUserInfo`,
        method: "post"
      }).then(response => {
        this.partyCurrentType = response.data.party.partyType;
        if ("SHIPMENT" == this.partyCurrentType) {
          this.$refs.HandlingData.isMessage = true;
          this.$refs.HandlingData.isService = true;
        }
      });
    },
    addAreaChild() {
      this.$refs.areaData.addArea();
    },
    // 获取区划代码
    getAreaData() {
      request({
        url: "/ntocc-basic-api/partyGroupConfig",
        method: "get",
        params: {
          type: "areaType",
          configKey: "areaCode"
        }
      }).then(response => {
        // this.getData(response.data.records[0].configValue);
      });
    },
    getlineOptionsData() {
      request({
        url: "/ntocc-basic-api/shipmentLine",
        method: "get",
        params: {
          shipmentUserCode:
            this.parentData == undefined ? "" : this.parentData.partyCode,
          pageSize: 1000
        }
      }).then(response => {
        this.dictData = response.data.records;
        this.dictData.map(item => {
          this.lineOptionsData.push(
            Object.assign({}, { value: item.code, label: item.name })
          );
        });
        this.lineForm.domains[0].lineOptions = this.lineOptionsData;
        this.getVehicleType();
      });
    },
    getVehicleType() {
      request({
        url: "/ntocc-basic-api/dict/listDict",
        method: "get",
        params: { types: "vehicleClassification" }
      }).then(response => {
        this.dictData = response.data[0].dictList;
        this.dictData.map(item => {
          this.vehicleData.push(
            Object.assign({}, { value: item.code, label: item.name })
          );
        });
        //回调数据
        this.findList();
      });
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "/ntocc-ctms-api/ctmsPriceStructure/personList",
          method: "get",
          params: {
            shipmentUserCode:
              this.parentData == undefined ? "" : this.parentData.partyCode
          }
        }).then(response => {
          this.priceReturnData = response.data;
          var kilometreFormData = this.kilometreForm.domains;
          this.kilometreForm.domains = [];
          var weightdomainsData = this.weightForm.weightdomains;
          this.weightForm.weightdomains = [];
          var piecedomainsData = this.pieceForm.piecedomains;
          this.pieceForm.piecedomains = [];
          var spotdomainsData = this.spotForm.spotdomains;
          this.spotForm.spotdomains = [];
          var volumedomainsData = this.volumeForm.volumedomains;
          this.volumeForm.volumedomains = [];
          var vehicleTableData = this.$refs.vehiclePriceData.form.tableData;
          this.$refs.vehiclePriceData.form.tableData = [];
          var vehicledomainsData = this.$refs.vehiclePriceData.form.domains;
          this.$refs.vehiclePriceData.form.domains = [];
          var linedomainData = this.lineForm.domains;
          this.lineForm.domains = [];
          var HandlingTableData = this.$refs.HandlingData.handlingtForm
            .tableData;
          this.$refs.HandlingData.handlingtForm.tableData = [];
          //区域线路计费

          var areaDataTableData = this.$refs.areaData.form.domains;
          this.$refs.areaData.form.domains = [];

          this.priceReturnData.map((item, index) => {
            this.radio1 = item.defaultBillingMethod.toString();
            if ("0" == item.priceType) {
              //回调公里数计费
              this.kilometreForm.domains.push(Object.assign({}, item));

              this.isRemoveKilometre = true;
            }
            if ("1" == item.priceType) {
              //回调重量计费
              this.weightForm.weightdomains.push(Object.assign({}, item));
              this.isWeightRemove = true;
            }
            if ("2" == item.priceType) {
              //回调件数计费
              this.pieceForm.piecedomains.push(Object.assign({}, item));
              this.pieceRemove = true;
            }
            if ("3" == item.priceType) {
              //回调点数计费
              this.spotForm.spotdomains.push(Object.assign({}, item));
              this.spotRemove = true;
            }
            if ("4" == item.priceType) {
              //回调体积计费
              this.volumeForm.volumedomains.push(Object.assign({}, item));
              this.volumeRemove = true;
            }
            if ("5" == item.priceType) {
              //回调包车计费
              this.$refs.vehiclePriceData.form.tableData.push(
                Object.assign(
                  {},
                  { price: item.price, limitEnd: item.limitEnd }
                )
              );
              this.$refs.vehiclePriceData.form.unitPrice = item.unitPrice;
            }
            if ("14" == item.priceType) {
              if (item.routelineCode !== "") {
                var areaItem = item;
                this.$refs.areaData.form.domains.push(
                  Object.assign({}, areaItem)
                );
                this.$refs.areaData.dataBack();
                this.$refs.areaData.isRemove = true;
              }
            }
            if ("8" == item.priceType) {
              //回调线路计费
              this.lineForm.domains.push(
                Object.assign(
                  {},
                  {
                    lineData: item.routelineCode,
                    lineOptions: this.lineOptionsData,
                    linePrice: item.price
                  }
                )
              );
              this.isRemove = true;
            }
            if ("12" == item.priceType) {
              //回调车型计费
              this.$refs.vehiclePriceData.form.domains.push(
                Object.assign(
                  {},
                  {
                    routelineCode: item.routelineCode,
                    vehicleOptions: this.vehicleData,
                    points: item.points
                  }
                )
              );
              this.$refs.vehiclePriceData.isRemove = true;
            }
            if ("6" == item.priceType) {
              //回调装卸费
              if (item.unit == "4") {
                this.$refs.HandlingData.handlingtForm.tableData.push(
                  Object.assign(
                    {},
                    { price: item.price, unit: "车", value: item.unit }
                  )
                );
              }
              if (item.unit == "3") {
                this.$refs.HandlingData.handlingtForm.tableData.push(
                  Object.assign(
                    {},
                    { price: item.price, unit: "方", value: item.unit }
                  )
                );
              }
              if (item.unit == "2") {
                this.$refs.HandlingData.handlingtForm.tableData.push(
                  Object.assign(
                    {},
                    { price: item.price, unit: "点", value: item.unit }
                  )
                );
              }
              if (item.unit == "1") {
                this.$refs.HandlingData.handlingtForm.tableData.push(
                  Object.assign(
                    {},
                    { price: item.price, unit: "件", value: item.unit }
                  )
                );
              }
              if (item.unit == "0") {
                this.$refs.HandlingData.handlingtForm.tableData.push(
                  Object.assign(
                    {},
                    { price: item.price, unit: "千克", value: item.unit }
                  )
                );
              }
            }
            if ("9" == item.priceType) {
              //回调加急费
              this.$refs.HandlingData.UrgentForm.points = item.points;
            }
            if ("10" == item.priceType) {
              //回调信息费
              this.$refs.HandlingData.messageForm.price = item.price;
              this.$refs.HandlingData.messageForm.points = item.points;
            }
            if ("16" == item.priceType) {
              //回调等候费
              this.$refs.HandlingData.WaitFeeForm.price = item.price;
              this.$refs.HandlingData.WaitFeeForm.unitPrice = item.unitPrice;
              this.$refs.HandlingData.WaitFeeForm.limitEnd = item.limitEnd;
            }
            if ("11" == item.priceType) {
              //回调代收款手续费
              this.$refs.HandlingData.serviceForm.price = item.price;
              this.$refs.HandlingData.serviceForm.points = item.points;
            }
            //附加费
          });
          if (this.kilometreForm.domains.length == 0) {
            this.kilometreForm.domains = kilometreFormData;
          }
          if (this.weightForm.weightdomains.length == 0) {
            this.weightForm.weightdomains = weightdomainsData;
          }
          if (this.pieceForm.piecedomains.length == 0) {
            this.pieceForm.piecedomains = piecedomainsData;
          }
          if (this.spotForm.spotdomains.length == 0) {
            this.spotForm.spotdomains = spotdomainsData;
          }
          if (this.volumeForm.volumedomains.length == 0) {
            this.volumeForm.volumedomains = volumedomainsData;
          }
          if (this.$refs.vehiclePriceData.form.tableData.length == 0) {
            this.$refs.vehiclePriceData.form.tableData = vehicleTableData;
          }
          if (this.$refs.vehiclePriceData.form.domains.length == 0) {
            this.$refs.vehiclePriceData.form.domains = vehicledomainsData;
          }
          if (this.lineForm.domains.length == 0) {
            this.lineForm.domains = linedomainData;
          }
          if (this.$refs.HandlingData.handlingtForm.tableData.length == 0) {
            this.$refs.HandlingData.handlingtForm.tableData = HandlingTableData;
          }
          if (this.$refs.areaData.form.domains.length == 0) {
            this.$refs.areaData.form.domains = areaDataTableData;
          }
        });
        request({
          url: "/ntocc-ctms-api/userPriceStructure/personOne",
          method: "get",
          params: {
            shipmentUserCode:
              this.parentData == undefined ? "" : this.parentData.partyCode
          }
        }).then(response => {
          var data = response.data;
          if (data != null) {
            this.$refs.HandlingData.handlingtForm.isHanding = data.isHanding.toString();
            this.$refs.HandlingData.handlingtForm.isTotal = data.isTotal.toString();
            this.$refs.HandlingData.UrgentForm.isUrgent = data.isUrgent.toString();
            this.$refs.HandlingData.messageForm.isInfo = data.isInfo.toString();
            this.$refs.HandlingData.serviceForm.isProcedure = data.isProcedure.toString();
            this.$refs.HandlingData.RefrigerationFeeForm.isRefrigeration = data.isRefrigeration.toString();
            this.$refs.HandlingData.WaitFeeForm.isWaitFee = data.isWaitFee.toString();
            this.$refs.HandlingData.otherFeeForm.isHighSpeedFee = data.isHighSpeedFee.toString();
            this.$refs.HandlingData.otherFeeForm.isParkingFee = data.isParkingFee.toString();
            this.$refs.HandlingData.otherFeeForm.isRollTollFee = data.isRollTollFee.toString();
            this.$refs.HandlingData.otherFeeForm.isWarehousingFee = data.isWarehousingFee.toString();
          }
        });
      });
    },
    //增加公里数计费
    addKilometre() {
      this.kilometreForm.domains.push({
        key: Date.now(),
        defaultBillingMethod: "0",
        limitEnd: "", //千克/方/件/点计量范围
        limitFrom: 0, //千克/方/件/点计量起始范围,
        points: 0, //百分比
        price: "",
        priceItem: "01", //价格项目（01配送计费，02运输计费）
        priceName: "公里数计费",
        priceType: "0", //费用类别（0, "公里数计费",1,"重量计费",2, "件数��费",3, "点数计费",4, "体积计费",5, "包车计费",6, "装卸费",7, "车数计费",8, "线路计费",9, "加急费",10, "信息费",11, "代收款手续费",12, "车型费用")13, "综合最大值";）
        rangeEnd: "", //组合计费 里程终止范围
        rangeFrom: "", //组合计费 里程起始范围
        rangeUnitPrice: 0,
        routelineCode: "", //线路code或者是车型code
        shipmentUserCode: "", //托运人用户code，对应sys_party表code
        unit: 0, //单位（非必传）
        unitPrice: "" //（单价）
      });
      this.isRemoveKilometre = true;
      this.kilometreWidth = 22;
    },
    // 删除公里数
    removeKilometre(item) {
      var delId;
      this.kilometreForm.domains.map((val, index) => {
        if (val.key == item.key) {
          delId = index;
        }
      });
      if (this.kilometreForm.domains.length > 1) {
        this.kilometreForm.domains.splice(delId, 1);
      } else {
        this.isRemoveKilometre = false;
        this.kilometreWidth = 24;
        this.$refs.KMruleForm.resetFields();
      }
    },
    // 增加路线
    addLine() {
      // if (this.lineForm.domains.length < 3) {
      this.lineForm.domains.push({
        key: Date.now(),
        lineData: "",
        lineOptions: this.lineOptionsData,
        linePrice: ""
      });
      this.isRemove = true;
      this.lineWidth = 22;
      // }
    },
    // 删除路线
    removeLine(item) {
      var delId;
      this.lineForm.domains.map((val, index) => {
        if (val.key == item.key) {
          delId = index;
        }
      });
      if (this.lineForm.domains.length > 1) {
        this.lineForm.domains.splice(delId, 1);
      } else {
        this.isRemove = false;
        this.lineWidth = 24;
        this.$refs.lineRuleForm.resetFields();
      }
    },
    // 增加重量计费
    addWeight() {
      if (this.weightForm.weightdomains.length < 3) {
        this.weightForm.weightdomains.push({
          key: Date.now(),
          defaultBillingMethod: "0", //默认计费方式 0:公里数计费,1:重量/体积/件数/点数计费,2:线路计费
          limitEnd: "", //千克/方/件/点计量范围
          limitFrom: "", //千克/方/件/点计量起始范围,
          points: 0, //百分比
          price: "", //起步价
          priceItem: "01", //价格项目（01配送计费，02运输计费）
          priceName: "重量计费", //费用类别名称（公里数计费）
          priceType: "1", //费用类别（0, "公里数计费",1,"重量计费",2, "件数计费",3, "点数计费",4, "体积计费",5, "包车计费",6, "装卸费",7, "车数计费",8, "线路计费",9, "加急费",10, "信息费",11, "代收款手续费",12, "车型费用")13, "综合最大值";）
          rangeEnd: "", //组合计费 里程终止范围
          rangeFrom: 0, //组合计费 里程起始范围
          rangeUnitPrice: "", //组合计费 里程单价
          routelineCode: "", //线路code或者是车型code
          shipmentUserCode: "", //托运人用户code，对应sys_party表code（非必传）
          unit: "0", //单位（非必传）
          unitPrice: "" //（单价）
        });
        this.isWeightRemove = true;
        this.weightWidth = 19;
      } else {
        this.$message({ message: "最多支持三个阶段计费" });
      }
    },
    // 删除重量计费
    removeWeight(item) {
      var delId;
      this.weightForm.weightdomains.map((val, index) => {
        if (val.key == item.key) {
          delId = index;
        }
      });
      if (this.weightForm.weightdomains.length > 1) {
        this.weightForm.weightdomains.splice(delId, 1);
      } else {
        this.kilometreWidth = 22;
        this.isWeightRemove = false;
        this.$refs.KMruleForm.resetFields();
      }
    },

    // 增加件数计费
    addPiece() {
      if (this.pieceForm.piecedomains.length < 3) {
        this.pieceForm.piecedomains.push({
          key: Date.now(),
          defaultBillingMethod: "0", //默认计费方式 0:公里数计费,1:重量/体积/件数/点数计费,2:线路计费
          limitEnd: "", //千克/方/件/点计量范围
          limitFrom: "", //千克/方/件/点计量起始范围,
          points: 0, //百分比
          price: "", //起步价
          priceItem: "01", //价格项目（01配送计费，02运输计费）
          priceName: "件数计费", //费用类别名称（公里数计费）
          priceType: 2, //费用类别（0, "公里数计费",1,"重量计费",2, "件数计费",3, "点数计费",4, "体积计费",5, "包车计费",6, "装卸费",7, "车数计费",8, "线路计费",9, "加急费",10, "信息费",11, "代收款手续费",12, "车型费用")13, "综合最大值";）
          rangeEnd: "", //组合计费 里程终止范围
          rangeFrom: "", //组合计费 里程起始范围
          rangeUnitPrice: "", //组合计费 里程单价
          routelineCode: "", //线路code或者是车型code
          shipmentUserCode: "", //托运人用户code，对应sys_party表code（非必传）
          unit: "1", //单位
          unitPrice: "" //（单价）
        });
        this.pieceRemove = true;
        this.pieceWidth = 19;
      } else {
        this.$message({ message: "最多支持三个阶段计费" });
      }
    },
    // 删除件数计费
    removePiece(item) {
      var delId;
      this.pieceForm.piecedomains.map((val, index) => {
        if (val.key == item.key) {
          delId = index;
        }
      });
      if (this.pieceForm.piecedomains.length > 1) {
        this.pieceForm.piecedomains.splice(delId, 1);
      } else {
        this.pieceWidth = 22;
        this.pieceRemove = false;
        this.$refs.pieceRuleForm.resetFields();
      }
    },
    //增加点数计费 -合入dev
    addSpot() {
      if (this.spotForm.spotdomains.length < 3) {
        this.spotForm.spotdomains.push({
          key: Date.now(),
          defaultBillingMethod: "0", //默认计费方式 0:公里数计费,1:重量/体积/件数/点数计费,2:线路计费
          limitEnd: "", //千克/方/件/点计量范围
          limitFrom: "", //千克/方/件/点计量起始范围,
          points: 0, //百分比
          price: "", //起步价
          priceItem: "01", //价格项目（01配送计费，02运输计费）
          priceName: "点数计费", //费用类别名称（公里数计费）
          priceType: 3, //费用类别（0, "公里数计费",1,"重量计费",2, "件数计费",3, "点数计费",4, "体积计费",5, "包车计费",6, "装卸费",7, "车数计费",8, "线路计费",9, "加急费",10, "信息费",11, "代收款手续费",12, "车型费用")13, "综合最大值";）
          rangeEnd: "", //组合计费 里程终止范围
          rangeFrom: "", //组合计费 里程起始范围
          rangeUnitPrice: "", //组合计费 里程单价
          routelineCode: "", //线路code或者是车型code
          shipmentUserCode: "", //托运人用户code，对应sys_party表code（非必传）
          unit: "2", //单位
          unitPrice: "" //（单价）
        });
        this.spotRemove = true;
        this.spotWidth = 19;
      } else {
        this.$message({ message: "最多支持三个阶段计费" });
      }
    },
    // 删除点数计费
    removeSpot(item) {
      var delId;
      this.spotForm.spotdomains.map((val, index) => {
        if (val.key == item.key) {
          delId = index;
        }
      });
      if (this.spotForm.spotdomains.length > 1) {
        this.spotForm.spotdomains.splice(delId, 1);
      } else {
        this.spotRemove = false;
        this.spotWidth = 22;
        this.$refs.spotRuleForm.resetFields();
      }
    },
    // 增加体积计费
    addVolume() {
      if (this.volumeForm.volumedomains.length < 3) {
        this.volumeForm.volumedomains.push({
          key: Date.now(),
          defaultBillingMethod: "0", //默认计费方式 0:公里数计费,1:重量/体积/件数/点数计费,2:线路计费
          limitEnd: "", //千克/方/件/点计量范围
          limitFrom: "", //千克/方/件/点计量起始范围,
          points: 0, //百分比
          price: "", //起步价
          priceItem: "01", //价格项目（01配送计费，02运输计费）
          priceName: "体积计费", //费用类别名称（公里数计费）
          priceType: 4, //费用类别（0, "公里数计费",1,"重量计费",2, "件数计费",3, "点数计费",4, "体积计费",5, "包车计费",6, "装卸费",7, "车数计费",8, "线路计费",9, "加急费",10, "信息费",11, "代收款手续费",12, "车型费用")13, "综合最大值";）
          rangeEnd: "", //组合计费 里程终止范围
          rangeFrom: "", //组合计费 里程起始范围
          rangeUnitPrice: "", //组合计费 里程单价
          routelineCode: "", //线路code或者是车型code
          shipmentUserCode: "", //托运人用户code，对应sys_party表code（非必传）
          unit: "3", //单位
          unitPrice: "" //（单价）
        });
      } else {
        this.$message({ message: "最多支持三个阶段计费" });
      }
      this.volumeWidth = 19;
      this.volumeRemove = true;
    },
    // 删除体积计费
    removeVolume(item) {
      var delId;
      this.volumeForm.volumedomains.map((val, index) => {
        if (val.key == item.key) {
          delId = index;
        }
      });
      if (this.volumeForm.volumedomains.length > 1) {
        this.volumeForm.volumedomains.splice(delId, 1);
      } else {
        this.volumeWidth = 22;
        this.volumeRemove = false;
        this.$refs.volumeRuleForm.resetFields();
      }
    },
    //解决浮点数计算
    // accMul(arg1,arg2){
    //   var m=0,s1=arg1.toString(),s2=arg2.toString();
    //   try{m+=s1.split(".")[1].length}catch(e){}
    //   try{m+=s2.split(".")[1].length}catch(e){}
    //   return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
    //   },
    // 提交表单
    submitForm() {
      Loading.service();
      this.postList = {
        shipmentUserCode: "",
        ctmsPriceStructureList: [],
        ctmsUserPriceStructure: {
          priceItem: "01", //价格项目（01配送计费，02运输计费）
          groupCode: "", //机构代码(非必传)
          shipmentUserCode: "", //托运人用户code，对应sys_party表code(非必传)
          isTotal: 0, //是否计算最大综合值，默认0否，1是
          isHanding: 0, //是否存在装卸费，默认0否，1是
          isUrgent: 0, //是否存在加急费，默认0否，1是
          isInfo: 0, //是否存在信息费，默认0否，1是
          isProcedure: 0, //是否存在代收款手续费，默认0否，1是
          isRefrigeration: 0 //是否存在代收款手续费，默认0否，1是
        }
      };
      this.kilometreForm.domains.map(item => {
        this.postList.ctmsPriceStructureList.push(
          Object.assign(item, { defaultBillingMethod: this.radio1 })
        );
      });
      //线路计费
      this.lineForm.domains.map(item => {
        var lineDataArray = Object.assign({}, this.$options.data().initForm); //获取该组件初始状态下的initForm数组
        Object.assign(lineDataArray, { defaultBillingMethod: this.radio1 });
        Object.assign(lineDataArray, { priceType: 8 }); //线路计费
        Object.assign(lineDataArray, { price: item.linePrice });
        Object.assign(lineDataArray, { routelineCode: item.lineData });
        Object.assign(lineDataArray, { priceName: "线路计费" });
        this.postList.ctmsPriceStructureList.push(lineDataArray);
      });
      //区划件数计费
      this.$refs.areaData.form.domains.map(item => {
        item.routelineCode = item.currentCode.toString();
        var areaDataArray = Object.assign({}, this.$options.data().initForm); //获取该组件初始状态下的initForm数组
        Object.assign(areaDataArray, { defaultBillingMethod: this.radio1 });
        Object.assign(areaDataArray, { priceType: 14 }); //区划件数计费
        Object.assign(areaDataArray, { unitPrice: item.unitPrice });
        Object.assign(areaDataArray, { routelineCode: item.routelineCode });
        Object.assign(areaDataArray, { priceName: "区划件数计费" });
        this.postList.ctmsPriceStructureList.push(areaDataArray);
      });
      // 校验重量计费表单
      // var weightLimitFrom = 0;
      // var weightRangeFrom = 0;
      // var weight = this.weightForm.weightdomains.map(item => {
      //   Object.assign(item, { defaultBillingMethod: this.radio1 });
      //   Object.assign(item, { limitFrom: weightLimitFrom });
      //   Object.assign(item, { rangeFrom: weightRangeFrom });
      //   this.postList.ctmsPriceStructureList.push(Object.assign({}, item));
      //   weightLimitFrom = item.limitEnd;
      //   weightRangeFrom = item.rangeEnd;
      // });
      // // 校验件数计费表单
      // var pieceLimitFrom = 0;
      // var pieceRangeFrom = 0;
      // var piece = this.pieceForm.piecedomains.map(item => {
      //   Object.assign(item, { defaultBillingMethod: this.radio1 });
      //   Object.assign(item, { limitFrom: pieceLimitFrom });
      //   Object.assign(item, { rangeFrom: pieceRangeFrom });
      //   this.postList.ctmsPriceStructureList.push(Object.assign({}, item));
      //   pieceLimitFrom = item.limitEnd;
      //   pieceRangeFrom = item.rangeEnd;
      // });
      // // 校验点数计费表单
      // var spotLimitFrom = 0;
      // var spotRangeFrom = 0;
      // var spot = this.spotForm.spotdomains.map(item => {
      //   // this.$refs.spotRuleForm.validate(valid => {
      //   //   if (valid) {
      //   Object.assign(item, { defaultBillingMethod: this.radio1 });
      //   Object.assign(item, { limitFrom: spotLimitFrom });
      //   Object.assign(item, { rangeFrom: spotRangeFrom });
      //   this.postList.ctmsPriceStructureList.push(Object.assign({}, item));
      //   spotLimitFrom = item.limitEnd;
      //   spotRangeFrom = item.rangeEnd;
      // });
      // // 校验体积计费表单
      // var volumeLimitFrom = 0;
      // var volumeRangeFrom = 0;
      // var volume = this.volumeForm.volumedomains.map(item => {
      //   // this.$refs.volumeRuleForm.validate(valid => {
      //   //   if (valid) {
      //   Object.assign(item, { defaultBillingMethod: this.radio1 });
      //   Object.assign(item, { limitFrom: volumeLimitFrom });
      //   Object.assign(item, { rangeFrom: volumeRangeFrom });
      //   this.postList.ctmsPriceStructureList.push(Object.assign({}, item));
      //   volumeLimitFrom = item.limitEnd;
      //   volumeRangeFrom = item.rangeEnd;
      // });

      // // 包车计费表单
      // var vehicleLimitFrom = 0;
      // var vehicle = this.$refs.vehiclePriceData.form.tableData.map(item => {
      //   var vehicleArray = Object.assign({}, this.$options.data().initForm); //获取该组件初始状态下的initForm数组
      //   Object.assign(vehicleArray, { defaultBillingMethod: this.radio1 });
      //   Object.assign(vehicleArray, {
      //     unitPrice: this.$refs.vehiclePriceData.form.unitPrice
      //   });
      //   Object.assign(vehicleArray, { price: item.price });
      //   Object.assign(vehicleArray, { limitFrom: vehicleLimitFrom });
      //   Object.assign(vehicleArray, { limitEnd: item.limitEnd });
      //   Object.assign(vehicleArray, { priceName: "包车计费" });
      //   this.postList.ctmsPriceStructureList.push(vehicleArray);
      //   vehicleLimitFrom = item.limitEnd;
      // });
      // // 包车计费--车型费用
      // var vehicleType = this.$refs.vehiclePriceData.form.domains.map(item => {
      //   var vehicleTypeArray = Object.assign({}, this.$options.data().initForm); //获取该组件初始状态下的initForm数组
      //   Object.assign(vehicleTypeArray, { defaultBillingMethod: this.radio1 });
      //   Object.assign(vehicleTypeArray, { priceType: 12 }); //车型费用
      //   Object.assign(vehicleTypeArray, { points: item.points });
      //   Object.assign(vehicleTypeArray, { routelineCode: item.routelineCode });
      //   Object.assign(vehicleTypeArray, { priceName: "车型费用" });
      //   this.postList.ctmsPriceStructureList.push(vehicleTypeArray);
      // });

      // //装卸费
      // var handing = this.$refs.HandlingData.handlingtForm.tableData.map(
      //   item => {
      //     var handingArray = Object.assign({}, this.$options.data().initForm); //获取该组件初始状态下的initForm数组
      //     Object.assign(handingArray, { defaultBillingMethod: this.radio1 });
      //     Object.assign(handingArray, { priceType: 6 }); //装卸费
      //     Object.assign(handingArray, { price: item.price });
      //     Object.assign(handingArray, { unit: item.value });
      //     Object.assign(handingArray, { priceName: "装卸费" });
      //     this.postList.ctmsPriceStructureList.push(handingArray);
      //   }
      // );
      //加急费
      var item = this.$refs.HandlingData.UrgentForm;
      var urgentArray = Object.assign({}, this.$options.data().initForm); //获取该组件初始状态下的initForm数组
      Object.assign(urgentArray, { defaultBillingMethod: this.radio1 });
      Object.assign(urgentArray, { priceType: 9 }); //加急费
      Object.assign(urgentArray, { points: item.points });
      Object.assign(urgentArray, { priceName: "加急费" });
      this.postList.ctmsPriceStructureList.push(urgentArray);
      //信息费
      var infoItem = this.$refs.HandlingData.messageForm;
      var infoArray = Object.assign({}, this.$options.data().initForm); //获取该组件初始状态下的initForm数组
      Object.assign(infoArray, { defaultBillingMethod: this.radio1 });
      Object.assign(infoArray, { priceType: 10 }); //信息费
      Object.assign(infoArray, { price: infoItem.price });
      Object.assign(infoArray, { points: infoItem.points });
      Object.assign(infoArray, { priceName: "信息费" });
      this.postList.ctmsPriceStructureList.push(infoArray);
      //等候费
      var waitFeeItem = this.$refs.HandlingData.WaitFeeForm;
      var waitFeeArray = Object.assign({}, this.$options.data().initForm); //获取该组件初始状态下的initForm数组
      Object.assign(waitFeeArray, { defaultBillingMethod: this.radio1 });
      Object.assign(waitFeeArray, { priceType: 16 }); //信息费
      Object.assign(waitFeeArray, { price: waitFeeItem.price });
      Object.assign(waitFeeArray, { unitPrice: waitFeeItem.unitPrice });
      Object.assign(waitFeeArray, { limitEnd: waitFeeItem.limitEnd });
      Object.assign(waitFeeArray, { priceName: "等候费" });
      this.postList.ctmsPriceStructureList.push(waitFeeArray);
      //代收款手续费
      var serviceItem = this.$refs.HandlingData.serviceForm;
      var serviceArray = Object.assign({}, this.$options.data().initForm); //获取该组件初始状态下的initForm数组
      Object.assign(serviceArray, { defaultBillingMethod: this.radio1 });
      Object.assign(serviceArray, { priceType: 11 }); //代收款手续费
      Object.assign(serviceArray, { price: serviceItem.price });
      Object.assign(serviceArray, { points: serviceItem.points });
      Object.assign(serviceArray, { priceName: "代收款手续费" });
      this.postList.ctmsPriceStructureList.push(serviceArray);

      //制冷费
      // var item = this.$refs.HandlingData.RefrigerationFeeForm;
      var coldurgentArray = Object.assign({}, this.$options.data().initForm); //获取该组件初始状态下的initForm数组
      Object.assign(coldurgentArray, { defaultBillingMethod: this.radio1 });
      Object.assign(coldurgentArray, { priceType: 15 }); //制冷费
      Object.assign(coldurgentArray, { points: item.points });
      Object.assign(coldurgentArray, { priceName: "制冷费" });
      this.postList.ctmsPriceStructureList.push(coldurgentArray);

      //是否存在装卸费，加急费，信息费，代收款手续费，综合最大值~~
      this.postList.ctmsUserPriceStructure.priceItem = "01"; //价格项目（01配送计费，02运输计费）
      this.postList.ctmsUserPriceStructure.isTotal = this.$refs.HandlingData.handlingtForm.isTotal; //是否计算最大综合值，默认0否，1是
      this.postList.ctmsUserPriceStructure.isHanding = this.$refs.HandlingData.handlingtForm.isHanding; //是否存在装卸费，默认0否，1是
      this.postList.ctmsUserPriceStructure.isUrgent = this.$refs.HandlingData.UrgentForm.isUrgent; //是否存在加急费，默认0否，1是
      this.postList.ctmsUserPriceStructure.isInfo = this.$refs.HandlingData.messageForm.isInfo; //是否存在信息费，默认0否，1是
      this.postList.ctmsUserPriceStructure.isProcedure = this.$refs.HandlingData.serviceForm.isProcedure; //是否存在代收款手续费，默认0否，1是
      this.postList.ctmsUserPriceStructure.isRefrigeration = this.$refs.HandlingData.RefrigerationFeeForm.isRefrigeration; //是否存在制冷费，默认0否，1是
      this.postList.ctmsUserPriceStructure.isWaitFee = this.$refs.HandlingData.WaitFeeForm.isWaitFee; //是否存在等待费，默认0否，1是
      this.postList.ctmsUserPriceStructure.isHighSpeedFee = this.$refs.HandlingData.otherFeeForm.isHighSpeedFee; //是否存在高速费、停车费，默认0否，1是
      this.postList.ctmsUserPriceStructure.isParkingFee = this.$refs.HandlingData.otherFeeForm.isParkingFee; //是否存在高速费、停车费，默认0否，1是
      this.postList.ctmsUserPriceStructure.isRollTollFee = this.$refs.HandlingData.otherFeeForm.isRollTollFee; //是否存在过路费、过桥费，默认0否，1是
      this.postList.ctmsUserPriceStructure.isWarehousingFee = this.$refs.HandlingData.otherFeeForm.isWarehousingFee; //是否存在进仓费，默认0否，1是
      this.postList.shipmentUserCode =
        this.parentData == undefined ? "" : this.parentData.partyCode;
      var data = this.postList;
      new Promise(resolve => {
        Price(data).then(response => {
          this.$message({ message: response.msg, type: "success" });
          this.findList();
          Loading.service().close();
        });
        resolve();
      });
    },

    // 重置表单 方法
    resetForm() {
      this.$refs.KMruleForm.resetFields();
      this.kilometreForm.domains.splice(1);

      this.$refs.weightRuleForm.resetFields();
      this.weightForm.weightdomains.splice(1);

      this.$refs.volumeRuleForm.resetFields();
      this.volumeForm.volumedomains.splice(1);

      this.$refs.spotRuleForm.resetFields();
      this.spotForm.spotdomains.splice(1);

      this.$refs.pieceRuleForm.resetFields();
      this.pieceForm.piecedomains.splice(1);

      this.$refs.lineRuleForm.resetFields();
      this.lineForm.domains.splice(1);

      this.$refs.areaData.resetAreaForm();

      this.$refs.vehiclePriceData.resetVehicleForm();

      this.$refs.HandlingData.resetAllForm();

      this.radio1 = "0";
    }
  }
};
</script>
<style>
.price-System .el-card__body {
  padding: 5px 10px !important;
}
</style>
<style lang="scss" scoped>
.el-tabs__item {
  font-size: 18px;
  height: 50px;
  line-height: 50px;
}
.el-row {
  padding: 0 20px;
}
.el-card {
  margin-bottom: 10px;
}

.el-card:hover {
  border-color: rgb(64, 160, 255);
}
.el-radio {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
  padding: 0 20px;
}
.iconCount {
  padding-top: 10px;
  text-align: center;
}

.unitTitle .el-divider__text {
  font-size: 14px;
  color: rgb(64, 160, 255);
  font-weight: 700;
}
.addUnitStyle {
  width: 200px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

.orText {
  // line-height: 60px;
  height: 59px;
  line-height: 46px;
  text-align: center;
  font-size: 16px;
  // color: rgba(172, 217, 248,.2);
}
.unitTitle {
  font-size: 14px;
  font-weight: 700;
  color: #606266;
  margin-bottom: 10px;
}
.margintop {
  margin-top: 24px;
}
// .addLine {
//   float: right;
//   margin-right: 10px;
// }
.marginNone {
  margin: 0 !important;
}
.FormBox {
  background: rgba(172, 217, 248, 0.2);
  height: 115px;
  margin-bottom: 10px;
  padding: 10px 0 10px;
}
</style>
